// 156 trades | $2952 P&L | 65.4% WR | avg 2.5d hold
// 2024-03-25 → 2026-03-19
export const DEMO_TRADES = [
  {
    "uid": "demo-0001-msft-2024-03-25",
    "ticker": "MSFT",
    "entryDate": "2024-03-25",
    "exitDate": "2024-03-28",
    "entryTime": "9:40AM",
    "exitTime": "11:45AM",
    "strike": 420,
    "type": "Put",
    "expiration": "2024-04-05",
    "entryPrice": 0.16,
    "exitPrice": 0.15,
    "entryStock": 426.35,
    "exitStock": 426.67,
    "contracts": 3,
    "returnPct": -6.25,
    "pnl": -3,
    "notes": "Overnight hold — gap up at open, easy exit",
    "updatedAt": 1711324800000,
    "deleted": false
  },
  {
    "uid": "demo-0002-msft-2024-03-26",
    "ticker": "MSFT",
    "entryDate": "2024-03-26",
    "exitDate": "2024-03-26",
    "entryTime": "1:30PM",
    "exitTime": "2:23PM",
    "strike": 375,
    "type": "Call",
    "expiration": "2024-03-26",
    "entryPrice": 0.77,
    "exitPrice": 1.13,
    "entryStock": 368.33,
    "exitStock": 372.45,
    "contracts": 1,
    "returnPct": 46.75,
    "pnl": 36,
    "notes": "",
    "updatedAt": 1711411201000,
    "deleted": false
  },
  {
    "uid": "demo-0003-tsla-2024-04-04",
    "ticker": "TSLA",
    "entryDate": "2024-04-04",
    "exitDate": "2024-04-10",
    "entryTime": "10:05AM",
    "exitTime": "1:30PM",
    "strike": 325,
    "type": "Call",
    "expiration": "2024-04-19",
    "entryPrice": 0.43,
    "exitPrice": 0.38,
    "entryStock": 321.86,
    "exitStock": 319.83,
    "contracts": 1,
    "returnPct": -11.63,
    "pnl": -5,
    "notes": "Entered late in the day, exited next morning",
    "updatedAt": 1712188802000,
    "deleted": false
  },
  {
    "uid": "demo-0004-nvda-2024-04-05",
    "ticker": "NVDA",
    "entryDate": "2024-04-05",
    "exitDate": "2024-04-08",
    "entryTime": "3:20PM",
    "exitTime": "2:00PM",
    "strike": 122.5,
    "type": "Put",
    "expiration": "2024-04-19",
    "entryPrice": 0.31,
    "exitPrice": 0.37,
    "entryStock": 123.81,
    "exitStock": 122.31,
    "contracts": 5,
    "returnPct": 19.35,
    "pnl": 30,
    "notes": "Revenge trade after previous loss — need discipline",
    "updatedAt": 1712275203000,
    "deleted": false
  },
  {
    "uid": "demo-0005-nvda-2024-04-10",
    "ticker": "NVDA",
    "entryDate": "2024-04-10",
    "exitDate": "2024-04-10",
    "entryTime": "3:20PM",
    "exitTime": "3:31PM",
    "strike": 132.5,
    "type": "Put",
    "expiration": "2024-04-10",
    "entryPrice": 0.22,
    "exitPrice": 0.21,
    "entryStock": 136.91,
    "exitStock": 141.16,
    "contracts": 1,
    "returnPct": -4.55,
    "pnl": -1,
    "notes": "",
    "updatedAt": 1712707204000,
    "deleted": false
  },
  {
    "uid": "demo-0006-uber-2024-04-16",
    "ticker": "UBER",
    "entryDate": "2024-04-16",
    "exitDate": "2024-04-16",
    "entryTime": "10:20AM",
    "exitTime": "11:04AM",
    "strike": 77.5,
    "type": "Call",
    "expiration": "2024-04-16",
    "entryPrice": 0.82,
    "exitPrice": 2.72,
    "entryStock": 78.19,
    "exitStock": 81.77,
    "contracts": 2,
    "returnPct": 231.71,
    "pnl": 380,
    "notes": "",
    "updatedAt": 1713225605000,
    "deleted": false
  },
  {
    "uid": "demo-0007-msft-2024-04-17",
    "ticker": "MSFT",
    "entryDate": "2024-04-17",
    "exitDate": "2024-04-17",
    "entryTime": "1:15PM",
    "exitTime": "2:06PM",
    "strike": 405,
    "type": "Call",
    "expiration": "2024-04-17",
    "entryPrice": 0.29,
    "exitPrice": 0.31,
    "entryStock": 401.22,
    "exitStock": 405.44,
    "contracts": 1,
    "returnPct": 6.9,
    "pnl": 2,
    "notes": "Momentum play off earnings gap up",
    "updatedAt": 1713312006000,
    "deleted": false
  },
  {
    "uid": "demo-0008-pltr-2024-04-18",
    "ticker": "PLTR",
    "entryDate": "2024-04-18",
    "exitDate": "2024-04-25",
    "entryTime": "2:30PM",
    "exitTime": "9:45AM",
    "strike": 77.5,
    "type": "Call",
    "expiration": "2024-05-03",
    "entryPrice": 0.06,
    "exitPrice": 0.07,
    "entryStock": 71.82,
    "exitStock": 76.74,
    "contracts": 2,
    "returnPct": 16.67,
    "pnl": 2,
    "notes": "",
    "updatedAt": 1713398407000,
    "deleted": false
  },
  {
    "uid": "demo-0009-googl-2024-04-23",
    "ticker": "GOOGL",
    "entryDate": "2024-04-23",
    "exitDate": "2024-04-29",
    "entryTime": "12:15PM",
    "exitTime": "3:30PM",
    "strike": 152.5,
    "type": "Put",
    "expiration": "2024-05-03",
    "entryPrice": 0.2,
    "exitPrice": 0.35,
    "entryStock": 156.38,
    "exitStock": 154.07,
    "contracts": 1,
    "returnPct": 75,
    "pnl": 15,
    "notes": "Tight spread, clean fill",
    "updatedAt": 1713830408000,
    "deleted": false
  },
  {
    "uid": "demo-0010-crm-2024-05-02",
    "ticker": "CRM",
    "entryDate": "2024-05-02",
    "exitDate": "2024-05-07",
    "entryTime": "12:30PM",
    "exitTime": "9:50AM",
    "strike": 275,
    "type": "Call",
    "expiration": "2024-05-17",
    "entryPrice": 1.11,
    "exitPrice": 1.66,
    "entryStock": 274.28,
    "exitStock": 279.17,
    "contracts": 1,
    "returnPct": 49.55,
    "pnl": 55,
    "notes": "",
    "updatedAt": 1714608009000,
    "deleted": false
  },
  {
    "uid": "demo-0011-msft-2024-05-09",
    "ticker": "MSFT",
    "entryDate": "2024-05-09",
    "exitDate": "2024-05-09",
    "entryTime": "9:35AM",
    "exitTime": "9:51AM",
    "strike": 385,
    "type": "Call",
    "expiration": "2024-05-09",
    "entryPrice": 1.33,
    "exitPrice": 2,
    "entryStock": 382.44,
    "exitStock": 385.45,
    "contracts": 2,
    "returnPct": 50.38,
    "pnl": 134,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1715212810000,
    "deleted": false
  },
  {
    "uid": "demo-0012-coin-2024-05-20",
    "ticker": "COIN",
    "entryDate": "2024-05-20",
    "exitDate": "2024-05-29",
    "entryTime": "9:50AM",
    "exitTime": "2:40PM",
    "strike": 245,
    "type": "Put",
    "expiration": "2024-06-07",
    "entryPrice": 0.2,
    "exitPrice": 0.18,
    "entryStock": 249.78,
    "exitStock": 251.96,
    "contracts": 2,
    "returnPct": -10,
    "pnl": -4,
    "notes": "Broke key resistance level with volume",
    "updatedAt": 1716163211000,
    "deleted": false
  },
  {
    "uid": "demo-0013-crm-2024-05-20",
    "ticker": "CRM",
    "entryDate": "2024-05-20",
    "exitDate": "2024-05-21",
    "entryTime": "3:05PM",
    "exitTime": "11:30AM",
    "strike": 295,
    "type": "Call",
    "expiration": "2024-05-24",
    "entryPrice": 0.46,
    "exitPrice": 0.61,
    "entryStock": 291.11,
    "exitStock": 292.78,
    "contracts": 1,
    "returnPct": 32.61,
    "pnl": 15,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1716163212000,
    "deleted": false
  },
  {
    "uid": "demo-0014-aapl-2024-05-30",
    "ticker": "AAPL",
    "entryDate": "2024-05-30",
    "exitDate": "2024-05-30",
    "entryTime": "2:45PM",
    "exitTime": "3:36PM",
    "strike": 230,
    "type": "Put",
    "expiration": "2024-05-30",
    "entryPrice": 0.14,
    "exitPrice": 0.22,
    "entryStock": 234.81,
    "exitStock": 229.94,
    "contracts": 1,
    "returnPct": 57.14,
    "pnl": 8,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1717027213000,
    "deleted": false
  },
  {
    "uid": "demo-0015-amzn-2024-06-10",
    "ticker": "AMZN",
    "entryDate": "2024-06-10",
    "exitDate": "2024-06-12",
    "entryTime": "3:10PM",
    "exitTime": "9:40AM",
    "strike": 180,
    "type": "Put",
    "expiration": "2024-06-14",
    "entryPrice": 1.11,
    "exitPrice": 3.17,
    "entryStock": 180.48,
    "exitStock": 178.66,
    "contracts": 1,
    "returnPct": 185.59,
    "pnl": 206,
    "notes": "",
    "updatedAt": 1717977614000,
    "deleted": false
  },
  {
    "uid": "demo-0016-snap-2024-06-11",
    "ticker": "SNAP",
    "entryDate": "2024-06-11",
    "exitDate": "2024-06-11",
    "entryTime": "1:15PM",
    "exitTime": "2:05PM",
    "strike": 17,
    "type": "Call",
    "expiration": "2024-06-11",
    "entryPrice": 0.05,
    "exitPrice": 0.14,
    "entryStock": 11.83,
    "exitStock": 16.59,
    "contracts": 1,
    "returnPct": 180,
    "pnl": 9,
    "notes": "3-day hold, theta started to bite",
    "updatedAt": 1718064015000,
    "deleted": false
  },
  {
    "uid": "demo-0017-hims-2024-06-12",
    "ticker": "HIMS",
    "entryDate": "2024-06-12",
    "exitDate": "2024-06-17",
    "entryTime": "3:10PM",
    "exitTime": "9:35AM",
    "strike": 50,
    "type": "Call",
    "expiration": "2024-06-21",
    "entryPrice": 0.4,
    "exitPrice": 0.47,
    "entryStock": 50.1,
    "exitStock": 54.11,
    "contracts": 2,
    "returnPct": 17.5,
    "pnl": 14,
    "notes": "",
    "updatedAt": 1718150416000,
    "deleted": false
  },
  {
    "uid": "demo-0018-nvda-2024-06-14",
    "ticker": "NVDA",
    "entryDate": "2024-06-14",
    "exitDate": "2024-06-14",
    "entryTime": "11:00AM",
    "exitTime": "11:51AM",
    "strike": 127.5,
    "type": "Call",
    "expiration": "2024-06-14",
    "entryPrice": 0.69,
    "exitPrice": 0.67,
    "entryStock": 124.82,
    "exitStock": 122.92,
    "contracts": 1,
    "returnPct": -2.9,
    "pnl": -2,
    "notes": "Chased this one — should've waited",
    "updatedAt": 1718323217000,
    "deleted": false
  },
  {
    "uid": "demo-0019-aapl-2024-06-26",
    "ticker": "AAPL",
    "entryDate": "2024-06-26",
    "exitDate": "2024-06-26",
    "entryTime": "3:40PM",
    "exitTime": "4:00PM",
    "strike": 215,
    "type": "Put",
    "expiration": "2024-06-26",
    "entryPrice": 1.43,
    "exitPrice": 1.39,
    "entryStock": 213.22,
    "exitStock": 215.54,
    "contracts": 1,
    "returnPct": -2.8,
    "pnl": -4,
    "notes": "Caught the trend continuation",
    "updatedAt": 1719360018000,
    "deleted": false
  },
  {
    "uid": "demo-0020-tsla-2024-06-27",
    "ticker": "TSLA",
    "entryDate": "2024-06-27",
    "exitDate": "2024-06-27",
    "entryTime": "2:50PM",
    "exitTime": "3:04PM",
    "strike": 350,
    "type": "Call",
    "expiration": "2024-06-27",
    "entryPrice": 3.67,
    "exitPrice": 10.93,
    "entryStock": 350.91,
    "exitStock": 352.14,
    "contracts": 2,
    "returnPct": 197.82,
    "pnl": 1452,
    "notes": "",
    "updatedAt": 1719446419000,
    "deleted": false
  },
  {
    "uid": "demo-0021-meta-2024-07-08",
    "ticker": "META",
    "entryDate": "2024-07-08",
    "exitDate": "2024-07-15",
    "entryTime": "3:00PM",
    "exitTime": "11:45AM",
    "strike": 535,
    "type": "Call",
    "expiration": "2024-07-19",
    "entryPrice": 1.65,
    "exitPrice": 2.22,
    "entryStock": 532.58,
    "exitStock": 533.7,
    "contracts": 1,
    "returnPct": 34.55,
    "pnl": 57,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1720396820000,
    "deleted": false
  },
  {
    "uid": "demo-0022-crwd-2024-07-16",
    "ticker": "CRWD",
    "entryDate": "2024-07-16",
    "exitDate": "2024-07-17",
    "entryTime": "2:15PM",
    "exitTime": "9:45AM",
    "strike": 370,
    "type": "Put",
    "expiration": "2024-07-19",
    "entryPrice": 3.24,
    "exitPrice": 4.18,
    "entryStock": 369.94,
    "exitStock": 367.33,
    "contracts": 1,
    "returnPct": 29.01,
    "pnl": 94,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1721088021000,
    "deleted": false
  },
  {
    "uid": "demo-0023-tsla-2024-07-25",
    "ticker": "TSLA",
    "entryDate": "2024-07-25",
    "exitDate": "2024-08-06",
    "entryTime": "2:45PM",
    "exitTime": "10:10AM",
    "strike": 335,
    "type": "Put",
    "expiration": "2024-08-09",
    "entryPrice": 1.68,
    "exitPrice": 2.32,
    "entryStock": 334.52,
    "exitStock": 333.76,
    "contracts": 1,
    "returnPct": 38.1,
    "pnl": 64,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1721865622000,
    "deleted": false
  },
  {
    "uid": "demo-0024-nvda-2024-08-05",
    "ticker": "NVDA",
    "entryDate": "2024-08-05",
    "exitDate": "2024-08-06",
    "entryTime": "9:40AM",
    "exitTime": "11:15AM",
    "strike": 125,
    "type": "Call",
    "expiration": "2024-08-16",
    "entryPrice": 0.35,
    "exitPrice": 1.18,
    "entryStock": 126.05,
    "exitStock": 127.91,
    "contracts": 2,
    "returnPct": 237.14,
    "pnl": 166,
    "notes": "Took profits too early, kept running after exit",
    "updatedAt": 1722816023000,
    "deleted": false
  },
  {
    "uid": "demo-0025-amzn-2024-08-06",
    "ticker": "AMZN",
    "entryDate": "2024-08-06",
    "exitDate": "2024-08-06",
    "entryTime": "2:45PM",
    "exitTime": "4:00PM",
    "strike": 205,
    "type": "Put",
    "expiration": "2024-08-06",
    "entryPrice": 1.35,
    "exitPrice": 0.39,
    "entryStock": 203.67,
    "exitStock": 205.77,
    "contracts": 2,
    "returnPct": -71.11,
    "pnl": -192,
    "notes": "Support held at round number",
    "updatedAt": 1722902424000,
    "deleted": false
  },
  {
    "uid": "demo-0026-aapl-2024-08-13",
    "ticker": "AAPL",
    "entryDate": "2024-08-13",
    "exitDate": "2024-08-14",
    "entryTime": "2:30PM",
    "exitTime": "3:20PM",
    "strike": 220,
    "type": "Call",
    "expiration": "2024-08-16",
    "entryPrice": 0.33,
    "exitPrice": 0.07,
    "entryStock": 218.29,
    "exitStock": 214.1,
    "contracts": 2,
    "returnPct": -78.79,
    "pnl": -52,
    "notes": "Faded the gap, worked out",
    "updatedAt": 1723507225000,
    "deleted": false
  },
  {
    "uid": "demo-0027-amzn-2024-08-13",
    "ticker": "AMZN",
    "entryDate": "2024-08-13",
    "exitDate": "2024-08-13",
    "entryTime": "1:30PM",
    "exitTime": "Expired",
    "strike": 192.5,
    "type": "Call",
    "expiration": "2024-08-13",
    "entryPrice": 2.42,
    "exitPrice": 0,
    "entryStock": 194.85,
    "exitStock": 192.64,
    "contracts": 3,
    "returnPct": -100,
    "pnl": -726,
    "notes": "Reversal off VWAP support",
    "updatedAt": 1723507226000,
    "deleted": false
  },
  {
    "uid": "demo-0028-googl-2024-08-15",
    "ticker": "GOOGL",
    "entryDate": "2024-08-15",
    "exitDate": "2024-08-16",
    "entryTime": "3:20PM",
    "exitTime": "9:55AM",
    "strike": 162.5,
    "type": "Put",
    "expiration": "2024-08-16",
    "entryPrice": 0.18,
    "exitPrice": 0.26,
    "entryStock": 163.31,
    "exitStock": 158.55,
    "contracts": 1,
    "returnPct": 44.44,
    "pnl": 8,
    "notes": "IV crush after earnings — lesson learned",
    "updatedAt": 1723680027000,
    "deleted": false
  },
  {
    "uid": "demo-0029-nvda-2024-08-26",
    "ticker": "NVDA",
    "entryDate": "2024-08-26",
    "exitDate": "2024-08-27",
    "entryTime": "2:50PM",
    "exitTime": "2:30PM",
    "strike": 132.5,
    "type": "Put",
    "expiration": "2024-09-06",
    "entryPrice": 0.53,
    "exitPrice": 0.76,
    "entryStock": 132.47,
    "exitStock": 131.45,
    "contracts": 1,
    "returnPct": 43.4,
    "pnl": 23,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1724630428000,
    "deleted": false
  },
  {
    "uid": "demo-0030-uber-2024-08-27",
    "ticker": "UBER",
    "entryDate": "2024-08-27",
    "exitDate": "2024-08-28",
    "entryTime": "2:00PM",
    "exitTime": "11:30AM",
    "strike": 77.5,
    "type": "Put",
    "expiration": "2024-09-06",
    "entryPrice": 0.27,
    "exitPrice": 0.47,
    "entryStock": 78.54,
    "exitStock": 76.46,
    "contracts": 1,
    "returnPct": 74.07,
    "pnl": 20,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1724716829000,
    "deleted": false
  },
  {
    "uid": "demo-0031-amzn-2024-08-28",
    "ticker": "AMZN",
    "entryDate": "2024-08-28",
    "exitDate": "2024-08-28",
    "entryTime": "11:30AM",
    "exitTime": "12:17PM",
    "strike": 182.5,
    "type": "Put",
    "expiration": "2024-08-28",
    "entryPrice": 0.12,
    "exitPrice": 0.14,
    "entryStock": 188.67,
    "exitStock": 186.61,
    "contracts": 2,
    "returnPct": 16.67,
    "pnl": 4,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1724803230000,
    "deleted": false
  },
  {
    "uid": "demo-0032-nvda-2024-08-29",
    "ticker": "NVDA",
    "entryDate": "2024-08-29",
    "exitDate": "2024-08-30",
    "entryTime": "3:00PM",
    "exitTime": "3:05PM",
    "strike": 130,
    "type": "Call",
    "expiration": "2024-09-06",
    "entryPrice": 0.54,
    "exitPrice": 0.08,
    "entryStock": 131.86,
    "exitStock": 127.87,
    "contracts": 1,
    "returnPct": -85.19,
    "pnl": -46,
    "notes": "Multi-day swing, caught the trend perfectly",
    "updatedAt": 1724889631000,
    "deleted": false
  },
  {
    "uid": "demo-0033-aapl-2024-08-30",
    "ticker": "AAPL",
    "entryDate": "2024-08-30",
    "exitDate": "2024-09-04",
    "entryTime": "12:00PM",
    "exitTime": "3:15PM",
    "strike": 225,
    "type": "Put",
    "expiration": "2024-09-13",
    "entryPrice": 0.43,
    "exitPrice": 0.52,
    "entryStock": 225.95,
    "exitStock": 225.21,
    "contracts": 1,
    "returnPct": 20.93,
    "pnl": 9,
    "notes": "",
    "updatedAt": 1724976032000,
    "deleted": false
  },
  {
    "uid": "demo-0034-meta-2024-09-04",
    "ticker": "META",
    "entryDate": "2024-09-04",
    "exitDate": "2024-09-04",
    "entryTime": "3:50PM",
    "exitTime": "4:00PM",
    "strike": 585,
    "type": "Call",
    "expiration": "2024-09-04",
    "entryPrice": 5.09,
    "exitPrice": 11.06,
    "entryStock": 585.08,
    "exitStock": 589.25,
    "contracts": 1,
    "returnPct": 117.29,
    "pnl": 597,
    "notes": "",
    "updatedAt": 1725408033000,
    "deleted": false
  },
  {
    "uid": "demo-0035-aapl-2024-09-13",
    "ticker": "AAPL",
    "entryDate": "2024-09-13",
    "exitDate": "2024-09-16",
    "entryTime": "9:45AM",
    "exitTime": "9:32AM",
    "strike": 210,
    "type": "Call",
    "expiration": "2024-09-20",
    "entryPrice": 3.92,
    "exitPrice": 4.38,
    "entryStock": 213.18,
    "exitStock": 213.88,
    "contracts": 2,
    "returnPct": 11.73,
    "pnl": 92,
    "notes": "Chased this one — should've waited",
    "updatedAt": 1726185634000,
    "deleted": false
  },
  {
    "uid": "demo-0036-googl-2024-09-23",
    "ticker": "GOOGL",
    "entryDate": "2024-09-23",
    "exitDate": "2024-09-27",
    "entryTime": "2:00PM",
    "exitTime": "1:00PM",
    "strike": 187.5,
    "type": "Call",
    "expiration": "2024-10-04",
    "entryPrice": 2.01,
    "exitPrice": 0.86,
    "entryStock": 189.32,
    "exitStock": 185.49,
    "contracts": 2,
    "returnPct": -57.21,
    "pnl": -230,
    "notes": "Faded the gap, worked out",
    "updatedAt": 1727049635000,
    "deleted": false
  },
  {
    "uid": "demo-0037-msft-2024-09-25",
    "ticker": "MSFT",
    "entryDate": "2024-09-25",
    "exitDate": "2024-10-07",
    "entryTime": "12:00PM",
    "exitTime": "9:38AM",
    "strike": 380,
    "type": "Put",
    "expiration": "2024-10-11",
    "entryPrice": 2.23,
    "exitPrice": 2.94,
    "entryStock": 378.7,
    "exitStock": 374.8,
    "contracts": 1,
    "returnPct": 31.84,
    "pnl": 71,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1727222436000,
    "deleted": false
  },
  {
    "uid": "demo-0038-meta-2024-09-26",
    "ticker": "META",
    "entryDate": "2024-09-26",
    "exitDate": "2024-10-01",
    "entryTime": "9:55AM",
    "exitTime": "10:30AM",
    "strike": 640,
    "type": "Put",
    "expiration": "2024-10-11",
    "entryPrice": 1.73,
    "exitPrice": 2.99,
    "entryStock": 638.45,
    "exitStock": 637.07,
    "contracts": 1,
    "returnPct": 72.83,
    "pnl": 126,
    "notes": "Momentum play off earnings gap up",
    "updatedAt": 1727308837000,
    "deleted": false
  },
  {
    "uid": "demo-0039-pltr-2024-09-27",
    "ticker": "PLTR",
    "entryDate": "2024-09-27",
    "exitDate": "2024-09-27",
    "entryTime": "9:38AM",
    "exitTime": "9:45AM",
    "strike": 85,
    "type": "Put",
    "expiration": "2024-09-27",
    "entryPrice": 0.71,
    "exitPrice": 0.92,
    "entryStock": 81.96,
    "exitStock": 80.64,
    "contracts": 1,
    "returnPct": 29.58,
    "pnl": 21,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1727395238000,
    "deleted": false
  },
  {
    "uid": "demo-0040-aapl-2024-09-30",
    "ticker": "AAPL",
    "entryDate": "2024-09-30",
    "exitDate": "2024-09-30",
    "entryTime": "10:05AM",
    "exitTime": "10:44AM",
    "strike": 230,
    "type": "Call",
    "expiration": "2024-09-30",
    "entryPrice": 1.16,
    "exitPrice": 0.76,
    "entryStock": 227.4,
    "exitStock": 225.62,
    "contracts": 1,
    "returnPct": -34.48,
    "pnl": -40,
    "notes": "IV crush after earnings — lesson learned",
    "updatedAt": 1727654439000,
    "deleted": false
  },
  {
    "uid": "demo-0041-nflx-2024-10-03",
    "ticker": "NFLX",
    "entryDate": "2024-10-03",
    "exitDate": "2024-10-04",
    "entryTime": "3:05PM",
    "exitTime": "2:50PM",
    "strike": 970,
    "type": "Call",
    "expiration": "2024-10-11",
    "entryPrice": 0.45,
    "exitPrice": 0.48,
    "entryStock": 964.97,
    "exitStock": 966.35,
    "contracts": 1,
    "returnPct": 6.67,
    "pnl": 3,
    "notes": "Power hour momentum play",
    "updatedAt": 1727913640000,
    "deleted": false
  },
  {
    "uid": "demo-0042-meta-2024-10-14",
    "ticker": "META",
    "entryDate": "2024-10-14",
    "exitDate": "2024-10-17",
    "entryTime": "3:10PM",
    "exitTime": "11:30AM",
    "strike": 565,
    "type": "Put",
    "expiration": "2024-10-25",
    "entryPrice": 4.72,
    "exitPrice": 6.37,
    "entryStock": 563.7,
    "exitStock": 559.8,
    "contracts": 2,
    "returnPct": 34.96,
    "pnl": 330,
    "notes": "Power hour momentum play",
    "updatedAt": 1728864041000,
    "deleted": false
  },
  {
    "uid": "demo-0043-amzn-2024-10-21",
    "ticker": "AMZN",
    "entryDate": "2024-10-21",
    "exitDate": "2024-10-21",
    "entryTime": "10:05AM",
    "exitTime": "10:37AM",
    "strike": 205,
    "type": "Call",
    "expiration": "2024-10-21",
    "entryPrice": 0.98,
    "exitPrice": 1.64,
    "entryStock": 203,
    "exitStock": 204.18,
    "contracts": 2,
    "returnPct": 67.35,
    "pnl": 132,
    "notes": "Support held at round number",
    "updatedAt": 1729468842000,
    "deleted": false
  },
  {
    "uid": "demo-0044-msft-2024-10-23",
    "ticker": "MSFT",
    "entryDate": "2024-10-23",
    "exitDate": "2024-10-31",
    "entryTime": "9:32AM",
    "exitTime": "2:00PM",
    "strike": 365,
    "type": "Put",
    "expiration": "2024-11-01",
    "entryPrice": 1.75,
    "exitPrice": 0.19,
    "entryStock": 366.04,
    "exitStock": 369.56,
    "contracts": 1,
    "returnPct": -89.14,
    "pnl": -156,
    "notes": "",
    "updatedAt": 1729641643000,
    "deleted": false
  },
  {
    "uid": "demo-0045-nflx-2024-10-28",
    "ticker": "NFLX",
    "entryDate": "2024-10-28",
    "exitDate": "2024-10-28",
    "entryTime": "10:05AM",
    "exitTime": "10:57AM",
    "strike": 940,
    "type": "Call",
    "expiration": "2024-10-28",
    "entryPrice": 2.55,
    "exitPrice": 0.28,
    "entryStock": 935.79,
    "exitStock": 935.03,
    "contracts": 2,
    "returnPct": -89.02,
    "pnl": -454,
    "notes": "Power hour momentum play",
    "updatedAt": 1730073644000,
    "deleted": false
  },
  {
    "uid": "demo-0046-hims-2024-10-29",
    "ticker": "HIMS",
    "entryDate": "2024-10-29",
    "exitDate": "2024-10-30",
    "entryTime": "1:15PM",
    "exitTime": "3:15PM",
    "strike": 50,
    "type": "Call",
    "expiration": "2024-11-01",
    "entryPrice": 0.15,
    "exitPrice": 0.24,
    "entryStock": 49.09,
    "exitStock": 52.05,
    "contracts": 1,
    "returnPct": 60,
    "pnl": 9,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1730160045000,
    "deleted": false
  },
  {
    "uid": "demo-0047-roku-2024-10-29",
    "ticker": "ROKU",
    "entryDate": "2024-10-29",
    "exitDate": "2024-11-18",
    "entryTime": "9:38AM",
    "exitTime": "12:30PM",
    "strike": 80,
    "type": "Call",
    "expiration": "2024-11-22",
    "entryPrice": 0.42,
    "exitPrice": 0.36,
    "entryStock": 79.35,
    "exitStock": 78.28,
    "contracts": 1,
    "returnPct": -14.29,
    "pnl": -6,
    "notes": "EMA 9/21 cross confirmed — clean entry",
    "updatedAt": 1730160046000,
    "deleted": false
  },
  {
    "uid": "demo-0048-hood-2024-10-30",
    "ticker": "HOOD",
    "entryDate": "2024-10-30",
    "exitDate": "2024-11-14",
    "entryTime": "11:00AM",
    "exitTime": "3:15PM",
    "strike": 43,
    "type": "Call",
    "expiration": "2024-11-15",
    "entryPrice": 0.1,
    "exitPrice": 0.08,
    "entryStock": 40.75,
    "exitStock": 38.04,
    "contracts": 2,
    "returnPct": -20,
    "pnl": -4,
    "notes": "Fed minutes reaction — quick scalp",
    "updatedAt": 1730246447000,
    "deleted": false
  },
  {
    "uid": "demo-0049-nvda-2024-11-05",
    "ticker": "NVDA",
    "entryDate": "2024-11-05",
    "exitDate": "2024-11-14",
    "entryTime": "9:55AM",
    "exitTime": "2:00PM",
    "strike": 120,
    "type": "Call",
    "expiration": "2024-11-15",
    "entryPrice": 0.34,
    "exitPrice": 0.99,
    "entryStock": 118.23,
    "exitStock": 119.25,
    "contracts": 2,
    "returnPct": 191.18,
    "pnl": 130,
    "notes": "Power hour momentum play",
    "updatedAt": 1730764848000,
    "deleted": false
  },
  {
    "uid": "demo-0050-msft-2024-11-06",
    "ticker": "MSFT",
    "entryDate": "2024-11-06",
    "exitDate": "2024-11-07",
    "entryTime": "12:00PM",
    "exitTime": "9:40AM",
    "strike": 390,
    "type": "Call",
    "expiration": "2024-11-15",
    "entryPrice": 1.11,
    "exitPrice": 1.18,
    "entryStock": 385.19,
    "exitStock": 386.44,
    "contracts": 1,
    "returnPct": 6.31,
    "pnl": 7,
    "notes": "Power hour momentum play",
    "updatedAt": 1730851249000,
    "deleted": false
  },
  {
    "uid": "demo-0051-amzn-2024-11-07",
    "ticker": "AMZN",
    "entryDate": "2024-11-07",
    "exitDate": "2024-11-11",
    "entryTime": "3:10PM",
    "exitTime": "3:05PM",
    "strike": 185,
    "type": "Put",
    "expiration": "2024-11-15",
    "entryPrice": 1.94,
    "exitPrice": 1.46,
    "entryStock": 183.34,
    "exitStock": 184.87,
    "contracts": 2,
    "returnPct": -24.74,
    "pnl": -96,
    "notes": "Quick 2-min scalp, in and out",
    "updatedAt": 1730937650000,
    "deleted": false
  },
  {
    "uid": "demo-0052-tsla-2024-11-12",
    "ticker": "TSLA",
    "entryDate": "2024-11-12",
    "exitDate": "2024-11-18",
    "entryTime": "2:30PM",
    "exitTime": "12:30PM",
    "strike": 355,
    "type": "Put",
    "expiration": "2024-11-22",
    "entryPrice": 5.13,
    "exitPrice": 9.15,
    "entryStock": 351.39,
    "exitStock": 350.71,
    "contracts": 1,
    "returnPct": 78.36,
    "pnl": 402,
    "notes": "Caught the trend continuation",
    "updatedAt": 1731369651000,
    "deleted": false
  },
  {
    "uid": "demo-0053-nvda-2024-11-20",
    "ticker": "NVDA",
    "entryDate": "2024-11-20",
    "exitDate": "2024-11-20",
    "entryTime": "3:15PM",
    "exitTime": "3:19PM",
    "strike": 145,
    "type": "Call",
    "expiration": "2024-11-20",
    "entryPrice": 0.08,
    "exitPrice": 0.1,
    "entryStock": 138.82,
    "exitStock": 140.76,
    "contracts": 1,
    "returnPct": 25,
    "pnl": 2,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1732060852000,
    "deleted": false
  },
  {
    "uid": "demo-0054-hims-2024-11-21",
    "ticker": "HIMS",
    "entryDate": "2024-11-21",
    "exitDate": "2024-11-21",
    "entryTime": "3:05PM",
    "exitTime": "3:48PM",
    "strike": 45,
    "type": "Put",
    "expiration": "2024-11-21",
    "entryPrice": 0.05,
    "exitPrice": 0.15,
    "entryStock": 50.3,
    "exitStock": 48.45,
    "contracts": 1,
    "returnPct": 200,
    "pnl": 10,
    "notes": "Was right on direction but strike too far OTM",
    "updatedAt": 1732147253000,
    "deleted": false
  },
  {
    "uid": "demo-0055-uber-2024-11-28",
    "ticker": "UBER",
    "entryDate": "2024-11-28",
    "exitDate": "2024-12-03",
    "entryTime": "10:00AM",
    "exitTime": "2:40PM",
    "strike": 80,
    "type": "Call",
    "expiration": "2024-12-06",
    "entryPrice": 0.7,
    "exitPrice": 0.81,
    "entryStock": 82.07,
    "exitStock": 84.31,
    "contracts": 1,
    "returnPct": 15.71,
    "pnl": 11,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1732752054000,
    "deleted": false
  },
  {
    "uid": "demo-0056-meta-2024-12-09",
    "ticker": "META",
    "entryDate": "2024-12-09",
    "exitDate": "2024-12-09",
    "entryTime": "10:45AM",
    "exitTime": "12:27PM",
    "strike": 615,
    "type": "Put",
    "expiration": "2024-12-09",
    "entryPrice": 2.12,
    "exitPrice": 1.48,
    "entryStock": 616.28,
    "exitStock": 620.56,
    "contracts": 1,
    "returnPct": -30.19,
    "pnl": -64,
    "notes": "",
    "updatedAt": 1733702455000,
    "deleted": false
  },
  {
    "uid": "demo-0057-nvda-2024-12-17",
    "ticker": "NVDA",
    "entryDate": "2024-12-17",
    "exitDate": "2024-12-17",
    "entryTime": "3:00PM",
    "exitTime": "3:58PM",
    "strike": 120,
    "type": "Put",
    "expiration": "2024-12-17",
    "entryPrice": 0.74,
    "exitPrice": 1.12,
    "entryStock": 121.73,
    "exitStock": 120.01,
    "contracts": 2,
    "returnPct": 51.35,
    "pnl": 76,
    "notes": "Was right on direction but strike too far OTM",
    "updatedAt": 1734393656000,
    "deleted": false
  },
  {
    "uid": "demo-0058-meta-2024-12-17",
    "ticker": "META",
    "entryDate": "2024-12-17",
    "exitDate": "2024-12-19",
    "entryTime": "3:10PM",
    "exitTime": "2:00PM",
    "strike": 555,
    "type": "Put",
    "expiration": "2024-12-27",
    "entryPrice": 5.24,
    "exitPrice": 0.79,
    "entryStock": 553.2,
    "exitStock": 557.12,
    "contracts": 1,
    "returnPct": -84.92,
    "pnl": -445,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1734393657000,
    "deleted": false
  },
  {
    "uid": "demo-0059-crwd-2024-12-18",
    "ticker": "CRWD",
    "entryDate": "2024-12-18",
    "exitDate": "2024-12-18",
    "entryTime": "1:45PM",
    "exitTime": "1:57PM",
    "strike": 340,
    "type": "Call",
    "expiration": "2024-12-18",
    "entryPrice": 2.03,
    "exitPrice": 2.78,
    "entryStock": 337.58,
    "exitStock": 342.41,
    "contracts": 1,
    "returnPct": 36.95,
    "pnl": 75,
    "notes": "Was right on direction but strike too far OTM",
    "updatedAt": 1734480058000,
    "deleted": false
  },
  {
    "uid": "demo-0060-tsla-2024-12-25",
    "ticker": "TSLA",
    "entryDate": "2024-12-25",
    "exitDate": "2024-12-27",
    "entryTime": "9:55AM",
    "exitTime": "1:30PM",
    "strike": 350,
    "type": "Call",
    "expiration": "2024-12-27",
    "entryPrice": 0.59,
    "exitPrice": 1.17,
    "entryStock": 347.92,
    "exitStock": 349,
    "contracts": 1,
    "returnPct": 98.31,
    "pnl": 58,
    "notes": "IV crush after earnings — lesson learned",
    "updatedAt": 1735084859000,
    "deleted": false
  },
  {
    "uid": "demo-0061-pltr-2024-12-26",
    "ticker": "PLTR",
    "entryDate": "2024-12-26",
    "exitDate": "2025-01-13",
    "entryTime": "10:30AM",
    "exitTime": "11:00AM",
    "strike": 70,
    "type": "Put",
    "expiration": "2025-01-17",
    "entryPrice": 0.25,
    "exitPrice": 0.15,
    "entryStock": 72.61,
    "exitStock": 74.38,
    "contracts": 1,
    "returnPct": -40,
    "pnl": -10,
    "notes": "Swung this over the weekend, risky but paid off",
    "updatedAt": 1735171260000,
    "deleted": false
  },
  {
    "uid": "demo-0062-tsla-2024-12-26",
    "ticker": "TSLA",
    "entryDate": "2024-12-26",
    "exitDate": "2024-12-26",
    "entryTime": "2:30PM",
    "exitTime": "2:59PM",
    "strike": 340,
    "type": "Call",
    "expiration": "2024-12-26",
    "entryPrice": 3.01,
    "exitPrice": 3.71,
    "entryStock": 341.43,
    "exitStock": 346.38,
    "contracts": 1,
    "returnPct": 23.26,
    "pnl": 70,
    "notes": "Multi-day swing, caught the trend perfectly",
    "updatedAt": 1735171261000,
    "deleted": false
  },
  {
    "uid": "demo-0063-tsla-2025-01-06",
    "ticker": "TSLA",
    "entryDate": "2025-01-06",
    "exitDate": "2025-01-06",
    "entryTime": "10:45AM",
    "exitTime": "11:42AM",
    "strike": 345,
    "type": "Put",
    "expiration": "2025-01-06",
    "entryPrice": 0.98,
    "exitPrice": 1.13,
    "entryStock": 351.42,
    "exitStock": 350.83,
    "contracts": 1,
    "returnPct": 15.31,
    "pnl": 15,
    "notes": "Reversal off VWAP support",
    "updatedAt": 1736121662000,
    "deleted": false
  },
  {
    "uid": "demo-0064-coin-2025-01-09",
    "ticker": "COIN",
    "entryDate": "2025-01-09",
    "exitDate": "2025-01-09",
    "entryTime": "2:00PM",
    "exitTime": "2:04PM",
    "strike": 230,
    "type": "Call",
    "expiration": "2025-01-09",
    "entryPrice": 0.4,
    "exitPrice": 0.55,
    "entryStock": 228.78,
    "exitStock": 230.11,
    "contracts": 2,
    "returnPct": 37.5,
    "pnl": 30,
    "notes": "Gamma squeeze candidate",
    "updatedAt": 1736380863000,
    "deleted": false
  },
  {
    "uid": "demo-0065-nvda-2025-01-17",
    "ticker": "NVDA",
    "entryDate": "2025-01-17",
    "exitDate": "2025-01-20",
    "entryTime": "10:30AM",
    "exitTime": "10:00AM",
    "strike": 122.5,
    "type": "Call",
    "expiration": "2025-01-24",
    "entryPrice": 1.02,
    "exitPrice": 0.56,
    "entryStock": 123.34,
    "exitStock": 120.71,
    "contracts": 1,
    "returnPct": -45.1,
    "pnl": -46,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1737072064000,
    "deleted": false
  },
  {
    "uid": "demo-0066-tsla-2025-01-20",
    "ticker": "TSLA",
    "entryDate": "2025-01-20",
    "exitDate": "2025-01-20",
    "entryTime": "10:20AM",
    "exitTime": "10:26AM",
    "strike": 345,
    "type": "Put",
    "expiration": "2025-01-20",
    "entryPrice": 3.71,
    "exitPrice": 1.91,
    "entryStock": 341.55,
    "exitStock": 341.98,
    "contracts": 3,
    "returnPct": -48.52,
    "pnl": -540,
    "notes": "RSI oversold bounce",
    "updatedAt": 1737331265000,
    "deleted": false
  },
  {
    "uid": "demo-0067-aapl-2025-01-20",
    "ticker": "AAPL",
    "entryDate": "2025-01-20",
    "exitDate": "2025-01-20",
    "entryTime": "3:10PM",
    "exitTime": "3:16PM",
    "strike": 220,
    "type": "Call",
    "expiration": "2025-01-20",
    "entryPrice": 1.1,
    "exitPrice": 0.8,
    "entryStock": 219.91,
    "exitStock": 216.75,
    "contracts": 1,
    "returnPct": -27.27,
    "pnl": -30,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1737331266000,
    "deleted": false
  },
  {
    "uid": "demo-0068-amzn-2025-01-24",
    "ticker": "AMZN",
    "entryDate": "2025-01-24",
    "exitDate": "2025-01-31",
    "entryTime": "10:00AM",
    "exitTime": "12:30PM",
    "strike": 215,
    "type": "Put",
    "expiration": "2025-02-07",
    "entryPrice": 0.29,
    "exitPrice": 0.21,
    "entryStock": 215.51,
    "exitStock": 220.25,
    "contracts": 1,
    "returnPct": -27.59,
    "pnl": -8,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1737676867000,
    "deleted": false
  },
  {
    "uid": "demo-0069-meta-2025-02-03",
    "ticker": "META",
    "entryDate": "2025-02-03",
    "exitDate": "2025-02-03",
    "entryTime": "10:05AM",
    "exitTime": "10:29AM",
    "strike": 575,
    "type": "Put",
    "expiration": "2025-02-03",
    "entryPrice": 6.86,
    "exitPrice": 1.27,
    "entryStock": 573.52,
    "exitStock": 577.87,
    "contracts": 1,
    "returnPct": -81.49,
    "pnl": -559,
    "notes": "Multi-day swing, caught the trend perfectly",
    "updatedAt": 1738540868000,
    "deleted": false
  },
  {
    "uid": "demo-0070-hims-2025-02-12",
    "ticker": "HIMS",
    "entryDate": "2025-02-12",
    "exitDate": "2025-02-12",
    "entryTime": "9:35AM",
    "exitTime": "10:40AM",
    "strike": 62.5,
    "type": "Call",
    "expiration": "2025-02-12",
    "entryPrice": 0.09,
    "exitPrice": 0.05,
    "entryStock": 58.35,
    "exitStock": 53.8,
    "contracts": 4,
    "returnPct": -44.44,
    "pnl": -16,
    "notes": "Quick 2-min scalp, in and out",
    "updatedAt": 1739318469000,
    "deleted": false
  },
  {
    "uid": "demo-0071-amd-2025-02-20",
    "ticker": "AMD",
    "entryDate": "2025-02-20",
    "exitDate": "2025-02-20",
    "entryTime": "12:15PM",
    "exitTime": "2:14PM",
    "strike": 115,
    "type": "Call",
    "expiration": "2025-02-20",
    "entryPrice": 0.95,
    "exitPrice": 0.69,
    "entryStock": 116.88,
    "exitStock": 112.36,
    "contracts": 1,
    "returnPct": -27.37,
    "pnl": -26,
    "notes": "Swung this over the weekend, risky but paid off",
    "updatedAt": 1740009670000,
    "deleted": false
  },
  {
    "uid": "demo-0072-pltr-2025-03-04",
    "ticker": "PLTR",
    "entryDate": "2025-03-04",
    "exitDate": "2025-03-06",
    "entryTime": "2:15PM",
    "exitTime": "10:20AM",
    "strike": 80,
    "type": "Call",
    "expiration": "2025-03-07",
    "entryPrice": 0.64,
    "exitPrice": 1.57,
    "entryStock": 80.06,
    "exitStock": 84.16,
    "contracts": 1,
    "returnPct": 145.31,
    "pnl": 93,
    "notes": "",
    "updatedAt": 1741046471000,
    "deleted": false
  },
  {
    "uid": "demo-0073-tsla-2025-03-05",
    "ticker": "TSLA",
    "entryDate": "2025-03-05",
    "exitDate": "2025-03-07",
    "entryTime": "3:20PM",
    "exitTime": "2:45PM",
    "strike": 355,
    "type": "Call",
    "expiration": "2025-03-14",
    "entryPrice": 0.29,
    "exitPrice": 0.18,
    "entryStock": 350.11,
    "exitStock": 345.38,
    "contracts": 2,
    "returnPct": -37.93,
    "pnl": -22,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1741132872000,
    "deleted": false
  },
  {
    "uid": "demo-0074-roku-2025-03-10",
    "ticker": "ROKU",
    "entryDate": "2025-03-10",
    "exitDate": "2025-03-11",
    "entryTime": "2:35PM",
    "exitTime": "11:00AM",
    "strike": 75,
    "type": "Call",
    "expiration": "2025-03-14",
    "entryPrice": 0.16,
    "exitPrice": 0.2,
    "entryStock": 74.45,
    "exitStock": 79.12,
    "contracts": 1,
    "returnPct": 25,
    "pnl": 4,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1741564873000,
    "deleted": false
  },
  {
    "uid": "demo-0075-nvda-2025-03-10",
    "ticker": "NVDA",
    "entryDate": "2025-03-10",
    "exitDate": "2025-03-18",
    "entryTime": "11:45AM",
    "exitTime": "9:45AM",
    "strike": 112.5,
    "type": "Call",
    "expiration": "2025-03-21",
    "entryPrice": 1.47,
    "exitPrice": 0.23,
    "entryStock": 113.42,
    "exitStock": 112.08,
    "contracts": 1,
    "returnPct": -84.35,
    "pnl": -124,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1741564874000,
    "deleted": false
  },
  {
    "uid": "demo-0076-crwd-2025-03-11",
    "ticker": "CRWD",
    "entryDate": "2025-03-11",
    "exitDate": "2025-03-11",
    "entryTime": "10:10AM",
    "exitTime": "10:40AM",
    "strike": 360,
    "type": "Call",
    "expiration": "2025-03-11",
    "entryPrice": 0.85,
    "exitPrice": 1.23,
    "entryStock": 355.57,
    "exitStock": 357.56,
    "contracts": 2,
    "returnPct": 44.71,
    "pnl": 76,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1741651275000,
    "deleted": false
  },
  {
    "uid": "demo-0077-amzn-2025-03-13",
    "ticker": "AMZN",
    "entryDate": "2025-03-13",
    "exitDate": "2025-03-14",
    "entryTime": "12:00PM",
    "exitTime": "Expired",
    "strike": 177.5,
    "type": "Put",
    "expiration": "2025-03-21",
    "entryPrice": 1.48,
    "exitPrice": 0,
    "entryStock": 177.46,
    "exitStock": 180.12,
    "contracts": 1,
    "returnPct": -100,
    "pnl": -148,
    "notes": "Quick 2-min scalp, in and out",
    "updatedAt": 1741824076000,
    "deleted": false
  },
  {
    "uid": "demo-0078-crwd-2025-03-25",
    "ticker": "CRWD",
    "entryDate": "2025-03-25",
    "exitDate": "2025-03-26",
    "entryTime": "1:30PM",
    "exitTime": "3:05PM",
    "strike": 395,
    "type": "Put",
    "expiration": "2025-04-04",
    "entryPrice": 0.38,
    "exitPrice": 0.21,
    "entryStock": 397.99,
    "exitStock": 400.59,
    "contracts": 1,
    "returnPct": -44.74,
    "pnl": -17,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1742860877000,
    "deleted": false
  },
  {
    "uid": "demo-0079-coin-2025-03-27",
    "ticker": "COIN",
    "entryDate": "2025-03-27",
    "exitDate": "2025-03-28",
    "entryTime": "3:05PM",
    "exitTime": "3:30PM",
    "strike": 240,
    "type": "Call",
    "expiration": "2025-04-04",
    "entryPrice": 0.88,
    "exitPrice": 1.18,
    "entryStock": 240.69,
    "exitStock": 242.97,
    "contracts": 1,
    "returnPct": 34.09,
    "pnl": 30,
    "notes": "",
    "updatedAt": 1743033678000,
    "deleted": false
  },
  {
    "uid": "demo-0080-nvda-2025-03-28",
    "ticker": "NVDA",
    "entryDate": "2025-03-28",
    "exitDate": "2025-03-28",
    "entryTime": "2:15PM",
    "exitTime": "3:20PM",
    "strike": 140,
    "type": "Call",
    "expiration": "2025-03-28",
    "entryPrice": 0.73,
    "exitPrice": 0.71,
    "entryStock": 139.33,
    "exitStock": 136.8,
    "contracts": 1,
    "returnPct": -2.74,
    "pnl": -2,
    "notes": "Faded the gap, worked out",
    "updatedAt": 1743120079000,
    "deleted": false
  },
  {
    "uid": "demo-0081-aapl-2025-04-09",
    "ticker": "AAPL",
    "entryDate": "2025-04-09",
    "exitDate": "2025-04-10",
    "entryTime": "12:00PM",
    "exitTime": "3:00PM",
    "strike": 210,
    "type": "Put",
    "expiration": "2025-04-18",
    "entryPrice": 0.32,
    "exitPrice": 0.59,
    "entryStock": 212.08,
    "exitStock": 209.68,
    "contracts": 2,
    "returnPct": 84.37,
    "pnl": 54,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1744156880000,
    "deleted": false
  },
  {
    "uid": "demo-0082-amzn-2025-04-16",
    "ticker": "AMZN",
    "entryDate": "2025-04-16",
    "exitDate": "2025-04-17",
    "entryTime": "3:15PM",
    "exitTime": "9:50AM",
    "strike": 195,
    "type": "Put",
    "expiration": "2025-04-25",
    "entryPrice": 0.81,
    "exitPrice": 1.29,
    "entryStock": 193.65,
    "exitStock": 188.77,
    "contracts": 1,
    "returnPct": 59.26,
    "pnl": 48,
    "notes": "3-day hold, theta started to bite",
    "updatedAt": 1744761681000,
    "deleted": false
  },
  {
    "uid": "demo-0083-googl-2025-04-22",
    "ticker": "GOOGL",
    "entryDate": "2025-04-22",
    "exitDate": "2025-04-22",
    "entryTime": "1:30PM",
    "exitTime": "2:24PM",
    "strike": 157.5,
    "type": "Call",
    "expiration": "2025-04-22",
    "entryPrice": 0.83,
    "exitPrice": 3.06,
    "entryStock": 156.17,
    "exitStock": 160.8,
    "contracts": 2,
    "returnPct": 268.67,
    "pnl": 446,
    "notes": "",
    "updatedAt": 1745280082000,
    "deleted": false
  },
  {
    "uid": "demo-0084-msft-2025-05-02",
    "ticker": "MSFT",
    "entryDate": "2025-05-02",
    "exitDate": "2025-05-09",
    "entryTime": "3:05PM",
    "exitTime": "3:40PM",
    "strike": 455,
    "type": "Call",
    "expiration": "2025-05-16",
    "entryPrice": 7.89,
    "exitPrice": 1.3,
    "entryStock": 458.08,
    "exitStock": 456.74,
    "contracts": 1,
    "returnPct": -83.52,
    "pnl": -659,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1746144083000,
    "deleted": false
  },
  {
    "uid": "demo-0085-roku-2025-05-08",
    "ticker": "ROKU",
    "entryDate": "2025-05-08",
    "exitDate": "2025-05-08",
    "entryTime": "9:35AM",
    "exitTime": "11:03AM",
    "strike": 85,
    "type": "Call",
    "expiration": "2025-05-08",
    "entryPrice": 0.89,
    "exitPrice": 0.35,
    "entryStock": 86.63,
    "exitStock": 81.8,
    "contracts": 1,
    "returnPct": -60.67,
    "pnl": -54,
    "notes": "",
    "updatedAt": 1746662484000,
    "deleted": false
  },
  {
    "uid": "demo-0086-aapl-2025-05-09",
    "ticker": "AAPL",
    "entryDate": "2025-05-09",
    "exitDate": "2025-05-16",
    "entryTime": "10:00AM",
    "exitTime": "2:15PM",
    "strike": 225,
    "type": "Put",
    "expiration": "2025-05-23",
    "entryPrice": 2.18,
    "exitPrice": 1.11,
    "entryStock": 221.8,
    "exitStock": 222.19,
    "contracts": 1,
    "returnPct": -49.08,
    "pnl": -107,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1746748885000,
    "deleted": false
  },
  {
    "uid": "demo-0087-amzn-2025-05-12",
    "ticker": "AMZN",
    "entryDate": "2025-05-12",
    "exitDate": "2025-05-13",
    "entryTime": "12:30PM",
    "exitTime": "3:00PM",
    "strike": 215,
    "type": "Put",
    "expiration": "2025-05-16",
    "entryPrice": 1.38,
    "exitPrice": 2.57,
    "entryStock": 213.01,
    "exitStock": 208.71,
    "contracts": 1,
    "returnPct": 86.23,
    "pnl": 119,
    "notes": "Support held at round number",
    "updatedAt": 1747008086000,
    "deleted": false
  },
  {
    "uid": "demo-0088-tsla-2025-05-20",
    "ticker": "TSLA",
    "entryDate": "2025-05-20",
    "exitDate": "2025-05-20",
    "entryTime": "12:15PM",
    "exitTime": "12:45PM",
    "strike": 370,
    "type": "Put",
    "expiration": "2025-05-20",
    "entryPrice": 0.75,
    "exitPrice": 1.13,
    "entryStock": 373.58,
    "exitStock": 372.93,
    "contracts": 2,
    "returnPct": 50.67,
    "pnl": 76,
    "notes": "Power hour momentum play",
    "updatedAt": 1747699287000,
    "deleted": false
  },
  {
    "uid": "demo-0089-nvda-2025-05-26",
    "ticker": "NVDA",
    "entryDate": "2025-05-26",
    "exitDate": "2025-05-27",
    "entryTime": "9:55AM",
    "exitTime": "3:40PM",
    "strike": 120,
    "type": "Call",
    "expiration": "2025-05-30",
    "entryPrice": 0.54,
    "exitPrice": 1.48,
    "entryStock": 121.74,
    "exitStock": 123.86,
    "contracts": 2,
    "returnPct": 174.07,
    "pnl": 188,
    "notes": "",
    "updatedAt": 1748217688000,
    "deleted": false
  },
  {
    "uid": "demo-0090-googl-2025-05-26",
    "ticker": "GOOGL",
    "entryDate": "2025-05-26",
    "exitDate": "2025-05-26",
    "entryTime": "2:50PM",
    "exitTime": "3:21PM",
    "strike": 175,
    "type": "Put",
    "expiration": "2025-05-26",
    "entryPrice": 0.23,
    "exitPrice": 0.08,
    "entryStock": 176.65,
    "exitStock": 177.41,
    "contracts": 1,
    "returnPct": -65.22,
    "pnl": -15,
    "notes": "",
    "updatedAt": 1748217689000,
    "deleted": false
  },
  {
    "uid": "demo-0091-nvda-2025-06-05",
    "ticker": "NVDA",
    "entryDate": "2025-06-05",
    "exitDate": "2025-06-12",
    "entryTime": "10:15AM",
    "exitTime": "1:30PM",
    "strike": 120,
    "type": "Call",
    "expiration": "2025-06-20",
    "entryPrice": 0.36,
    "exitPrice": 0.04,
    "entryStock": 120.7,
    "exitStock": 120.32,
    "contracts": 2,
    "returnPct": -88.89,
    "pnl": -64,
    "notes": "",
    "updatedAt": 1749081690000,
    "deleted": false
  },
  {
    "uid": "demo-0092-hims-2025-06-17",
    "ticker": "HIMS",
    "entryDate": "2025-06-17",
    "exitDate": "2025-06-25",
    "entryTime": "2:30PM",
    "exitTime": "10:15AM",
    "strike": 52.5,
    "type": "Call",
    "expiration": "2025-07-04",
    "entryPrice": 0.39,
    "exitPrice": 0.52,
    "entryStock": 53.91,
    "exitStock": 58.12,
    "contracts": 2,
    "returnPct": 33.33,
    "pnl": 26,
    "notes": "Broke even, lucky to get out",
    "updatedAt": 1750118491000,
    "deleted": false
  },
  {
    "uid": "demo-0093-meta-2025-06-23",
    "ticker": "META",
    "entryDate": "2025-06-23",
    "exitDate": "2025-06-23",
    "entryTime": "3:40PM",
    "exitTime": "4:00PM",
    "strike": 535,
    "type": "Call",
    "expiration": "2025-06-23",
    "entryPrice": 3.22,
    "exitPrice": 5.65,
    "entryStock": 533.94,
    "exitStock": 537.8,
    "contracts": 1,
    "returnPct": 75.47,
    "pnl": 243,
    "notes": "",
    "updatedAt": 1750636892000,
    "deleted": false
  },
  {
    "uid": "demo-0094-msft-2025-06-23",
    "ticker": "MSFT",
    "entryDate": "2025-06-23",
    "exitDate": "2025-06-25",
    "entryTime": "3:50PM",
    "exitTime": "3:40PM",
    "strike": 435,
    "type": "Call",
    "expiration": "2025-06-27",
    "entryPrice": 1.01,
    "exitPrice": 1.35,
    "entryStock": 435.24,
    "exitStock": 435.82,
    "contracts": 1,
    "returnPct": 33.66,
    "pnl": 34,
    "notes": "Overnight hold — gap up at open, easy exit",
    "updatedAt": 1750636893000,
    "deleted": false
  },
  {
    "uid": "demo-0095-crm-2025-06-30",
    "ticker": "CRM",
    "entryDate": "2025-06-30",
    "exitDate": "2025-07-01",
    "entryTime": "3:15PM",
    "exitTime": "2:35PM",
    "strike": 285,
    "type": "Put",
    "expiration": "2025-07-04",
    "entryPrice": 0.63,
    "exitPrice": 0.6,
    "entryStock": 285.3,
    "exitStock": 288.99,
    "contracts": 4,
    "returnPct": -4.76,
    "pnl": -12,
    "notes": "Averaged down — bad habit",
    "updatedAt": 1751241694000,
    "deleted": false
  },
  {
    "uid": "demo-0096-sofi-2025-07-03",
    "ticker": "SOFI",
    "entryDate": "2025-07-03",
    "exitDate": "2025-07-07",
    "entryTime": "3:30PM",
    "exitTime": "1:45PM",
    "strike": 18,
    "type": "Put",
    "expiration": "2025-07-11",
    "entryPrice": 0.1,
    "exitPrice": 0.14,
    "entryStock": 15.86,
    "exitStock": 12.1,
    "contracts": 1,
    "returnPct": 40,
    "pnl": 4,
    "notes": "",
    "updatedAt": 1751500895000,
    "deleted": false
  },
  {
    "uid": "demo-0097-msft-2025-07-04",
    "ticker": "MSFT",
    "entryDate": "2025-07-04",
    "exitDate": "2025-07-04",
    "entryTime": "2:50PM",
    "exitTime": "2:56PM",
    "strike": 455,
    "type": "Put",
    "expiration": "2025-07-04",
    "entryPrice": 6.73,
    "exitPrice": 9.37,
    "entryStock": 451.09,
    "exitStock": 447.17,
    "contracts": 1,
    "returnPct": 39.23,
    "pnl": 264,
    "notes": "Caught the trend continuation",
    "updatedAt": 1751587296000,
    "deleted": false
  },
  {
    "uid": "demo-0098-nvda-2025-07-07",
    "ticker": "NVDA",
    "entryDate": "2025-07-07",
    "exitDate": "2025-07-07",
    "entryTime": "9:40AM",
    "exitTime": "9:54AM",
    "strike": 122.5,
    "type": "Call",
    "expiration": "2025-07-07",
    "entryPrice": 0.13,
    "exitPrice": 0.17,
    "entryStock": 119.31,
    "exitStock": 123.33,
    "contracts": 1,
    "returnPct": 30.77,
    "pnl": 4,
    "notes": "Momentum play off earnings gap up",
    "updatedAt": 1751846497000,
    "deleted": false
  },
  {
    "uid": "demo-0099-aapl-2025-07-07",
    "ticker": "AAPL",
    "entryDate": "2025-07-07",
    "exitDate": "2025-07-08",
    "entryTime": "1:45PM",
    "exitTime": "10:05AM",
    "strike": 220,
    "type": "Call",
    "expiration": "2025-07-18",
    "entryPrice": 0.38,
    "exitPrice": 0.54,
    "entryStock": 219.76,
    "exitStock": 222.85,
    "contracts": 2,
    "returnPct": 42.11,
    "pnl": 32,
    "notes": "",
    "updatedAt": 1751846498000,
    "deleted": false
  },
  {
    "uid": "demo-0100-meta-2025-07-09",
    "ticker": "META",
    "entryDate": "2025-07-09",
    "exitDate": "2025-07-10",
    "entryTime": "9:38AM",
    "exitTime": "2:50PM",
    "strike": 540,
    "type": "Put",
    "expiration": "2025-07-11",
    "entryPrice": 2.48,
    "exitPrice": 2.89,
    "entryStock": 540.84,
    "exitStock": 536.86,
    "contracts": 1,
    "returnPct": 16.53,
    "pnl": 41,
    "notes": "Fed minutes reaction — quick scalp",
    "updatedAt": 1752019299000,
    "deleted": false
  },
  {
    "uid": "demo-0101-msft-2025-07-17",
    "ticker": "MSFT",
    "entryDate": "2025-07-17",
    "exitDate": "2025-07-22",
    "entryTime": "12:30PM",
    "exitTime": "10:00AM",
    "strike": 360,
    "type": "Call",
    "expiration": "2025-07-25",
    "entryPrice": 2.12,
    "exitPrice": 5.24,
    "entryStock": 360.3,
    "exitStock": 361.48,
    "contracts": 1,
    "returnPct": 147.17,
    "pnl": 312,
    "notes": "Faded the gap, worked out",
    "updatedAt": 1752710500000,
    "deleted": false
  },
  {
    "uid": "demo-0102-nvda-2025-07-24",
    "ticker": "NVDA",
    "entryDate": "2025-07-24",
    "exitDate": "2025-07-25",
    "entryTime": "3:20PM",
    "exitTime": "12:30PM",
    "strike": 137.5,
    "type": "Call",
    "expiration": "2025-08-01",
    "entryPrice": 0.56,
    "exitPrice": 0.3,
    "entryStock": 136.98,
    "exitStock": 136,
    "contracts": 1,
    "returnPct": -46.43,
    "pnl": -26,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1753315301000,
    "deleted": false
  },
  {
    "uid": "demo-0103-coin-2025-07-25",
    "ticker": "COIN",
    "entryDate": "2025-07-25",
    "exitDate": "2025-07-30",
    "entryTime": "1:30PM",
    "exitTime": "1:15PM",
    "strike": 265,
    "type": "Call",
    "expiration": "2025-08-01",
    "entryPrice": 2.67,
    "exitPrice": 2.06,
    "entryStock": 269.44,
    "exitStock": 268.22,
    "contracts": 1,
    "returnPct": -22.85,
    "pnl": -61,
    "notes": "Multi-day swing, caught the trend perfectly",
    "updatedAt": 1753401702000,
    "deleted": false
  },
  {
    "uid": "demo-0104-msft-2025-08-04",
    "ticker": "MSFT",
    "entryDate": "2025-08-04",
    "exitDate": "2025-08-05",
    "entryTime": "3:10PM",
    "exitTime": "10:30AM",
    "strike": 385,
    "type": "Call",
    "expiration": "2025-08-08",
    "entryPrice": 4.97,
    "exitPrice": 4.15,
    "entryStock": 385.57,
    "exitStock": 381.68,
    "contracts": 1,
    "returnPct": -16.5,
    "pnl": -82,
    "notes": "Overnight hold — gap up at open, easy exit",
    "updatedAt": 1754265703000,
    "deleted": false
  },
  {
    "uid": "demo-0105-sofi-2025-08-04",
    "ticker": "SOFI",
    "entryDate": "2025-08-04",
    "exitDate": "2025-08-05",
    "entryTime": "11:15AM",
    "exitTime": "9:55AM",
    "strike": 13,
    "type": "Call",
    "expiration": "2025-08-08",
    "entryPrice": 0.07,
    "exitPrice": 0.08,
    "entryStock": 15.18,
    "exitStock": 15.94,
    "contracts": 1,
    "returnPct": 14.29,
    "pnl": 1,
    "notes": "",
    "updatedAt": 1754265704000,
    "deleted": false
  },
  {
    "uid": "demo-0106-pltr-2025-08-05",
    "ticker": "PLTR",
    "entryDate": "2025-08-05",
    "exitDate": "2025-08-08",
    "entryTime": "12:15PM",
    "exitTime": "11:45AM",
    "strike": 65,
    "type": "Put",
    "expiration": "2025-08-15",
    "entryPrice": 0.17,
    "exitPrice": 0.27,
    "entryStock": 68.78,
    "exitStock": 67.87,
    "contracts": 2,
    "returnPct": 58.82,
    "pnl": 20,
    "notes": "Overextended entry, should've been a put",
    "updatedAt": 1754352105000,
    "deleted": false
  },
  {
    "uid": "demo-0107-amzn-2025-08-06",
    "ticker": "AMZN",
    "entryDate": "2025-08-06",
    "exitDate": "2025-08-06",
    "entryTime": "9:40AM",
    "exitTime": "9:53AM",
    "strike": 222.5,
    "type": "Put",
    "expiration": "2025-08-06",
    "entryPrice": 0.36,
    "exitPrice": 0.58,
    "entryStock": 223.89,
    "exitStock": 219.63,
    "contracts": 1,
    "returnPct": 61.11,
    "pnl": 22,
    "notes": "Quick 2-min scalp, in and out",
    "updatedAt": 1754438506000,
    "deleted": false
  },
  {
    "uid": "demo-0108-aapl-2025-08-08",
    "ticker": "AAPL",
    "entryDate": "2025-08-08",
    "exitDate": "2025-08-12",
    "entryTime": "9:45AM",
    "exitTime": "11:00AM",
    "strike": 260,
    "type": "Call",
    "expiration": "2025-08-15",
    "entryPrice": 0.24,
    "exitPrice": 0.28,
    "entryStock": 255.88,
    "exitStock": 260.74,
    "contracts": 1,
    "returnPct": 16.67,
    "pnl": 4,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1754611307000,
    "deleted": false
  },
  {
    "uid": "demo-0109-amd-2025-08-19",
    "ticker": "AMD",
    "entryDate": "2025-08-19",
    "exitDate": "2025-08-19",
    "entryTime": "3:20PM",
    "exitTime": "4:00PM",
    "strike": 117.5,
    "type": "Call",
    "expiration": "2025-08-19",
    "entryPrice": 0.37,
    "exitPrice": 0.5,
    "entryStock": 119.04,
    "exitStock": 124,
    "contracts": 1,
    "returnPct": 35.14,
    "pnl": 13,
    "notes": "Held 2 days waiting for the catalyst, worked",
    "updatedAt": 1755561708000,
    "deleted": false
  },
  {
    "uid": "demo-0110-hood-2025-08-27",
    "ticker": "HOOD",
    "entryDate": "2025-08-27",
    "exitDate": "2025-08-29",
    "entryTime": "11:15AM",
    "exitTime": "9:38AM",
    "strike": 34,
    "type": "Put",
    "expiration": "2025-09-05",
    "entryPrice": 0.13,
    "exitPrice": 0.2,
    "entryStock": 34.15,
    "exitStock": 32.66,
    "contracts": 1,
    "returnPct": 53.85,
    "pnl": 7,
    "notes": "Held through lunch chop — mistake",
    "updatedAt": 1756252909000,
    "deleted": false
  },
  {
    "uid": "demo-0111-hims-2025-08-28",
    "ticker": "HIMS",
    "entryDate": "2025-08-28",
    "exitDate": "2025-09-01",
    "entryTime": "1:15PM",
    "exitTime": "9:45AM",
    "strike": 55,
    "type": "Call",
    "expiration": "2025-09-05",
    "entryPrice": 0.25,
    "exitPrice": 0.31,
    "entryStock": 54.81,
    "exitStock": 59.51,
    "contracts": 2,
    "returnPct": 24,
    "pnl": 12,
    "notes": "Entered late in the day, exited next morning",
    "updatedAt": 1756339310000,
    "deleted": false
  },
  {
    "uid": "demo-0112-pltr-2025-09-03",
    "ticker": "PLTR",
    "entryDate": "2025-09-03",
    "exitDate": "2025-09-04",
    "entryTime": "3:00PM",
    "exitTime": "3:15PM",
    "strike": 65,
    "type": "Put",
    "expiration": "2025-09-12",
    "entryPrice": 0.21,
    "exitPrice": 0.3,
    "entryStock": 70.45,
    "exitStock": 69.7,
    "contracts": 1,
    "returnPct": 42.86,
    "pnl": 9,
    "notes": "Was right on direction but strike too far OTM",
    "updatedAt": 1756857711000,
    "deleted": false
  },
  {
    "uid": "demo-0113-coin-2025-09-10",
    "ticker": "COIN",
    "entryDate": "2025-09-10",
    "exitDate": "2025-09-10",
    "entryTime": "1:30PM",
    "exitTime": "1:39PM",
    "strike": 265,
    "type": "Put",
    "expiration": "2025-09-10",
    "entryPrice": 0.88,
    "exitPrice": 1.01,
    "entryStock": 264.24,
    "exitStock": 262.56,
    "contracts": 2,
    "returnPct": 14.77,
    "pnl": 26,
    "notes": "",
    "updatedAt": 1757462512000,
    "deleted": false
  },
  {
    "uid": "demo-0114-hims-2025-09-22",
    "ticker": "HIMS",
    "entryDate": "2025-09-22",
    "exitDate": "2025-09-22",
    "entryTime": "11:45AM",
    "exitTime": "12:39PM",
    "strike": 60,
    "type": "Call",
    "expiration": "2025-09-22",
    "entryPrice": 0.52,
    "exitPrice": 0.73,
    "entryStock": 60.64,
    "exitStock": 64.8,
    "contracts": 1,
    "returnPct": 40.38,
    "pnl": 21,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1758499313000,
    "deleted": false
  },
  {
    "uid": "demo-0115-amd-2025-09-24",
    "ticker": "AMD",
    "entryDate": "2025-09-24",
    "exitDate": "2025-09-25",
    "entryTime": "3:50PM",
    "exitTime": "9:40AM",
    "strike": 135,
    "type": "Put",
    "expiration": "2025-09-26",
    "entryPrice": 0.54,
    "exitPrice": 0.36,
    "entryStock": 135.18,
    "exitStock": 137.02,
    "contracts": 1,
    "returnPct": -33.33,
    "pnl": -18,
    "notes": "",
    "updatedAt": 1758672114000,
    "deleted": false
  },
  {
    "uid": "demo-0116-aapl-2025-09-25",
    "ticker": "AAPL",
    "entryDate": "2025-09-25",
    "exitDate": "2025-10-03",
    "entryTime": "3:50PM",
    "exitTime": "2:40PM",
    "strike": 220,
    "type": "Call",
    "expiration": "2025-10-10",
    "entryPrice": 0.62,
    "exitPrice": 0.8,
    "entryStock": 217.31,
    "exitStock": 222.02,
    "contracts": 2,
    "returnPct": 29.03,
    "pnl": 36,
    "notes": "Revenge trade after previous loss — need discipline",
    "updatedAt": 1758758515000,
    "deleted": false
  },
  {
    "uid": "demo-0117-msft-2025-09-26",
    "ticker": "MSFT",
    "entryDate": "2025-09-26",
    "exitDate": "2025-09-29",
    "entryTime": "9:32AM",
    "exitTime": "9:50AM",
    "strike": 430,
    "type": "Call",
    "expiration": "2025-10-03",
    "entryPrice": 4.54,
    "exitPrice": 2.63,
    "entryStock": 432.18,
    "exitStock": 429.76,
    "contracts": 5,
    "returnPct": -42.07,
    "pnl": -955,
    "notes": "",
    "updatedAt": 1758844916000,
    "deleted": false
  },
  {
    "uid": "demo-0118-amzn-2025-10-02",
    "ticker": "AMZN",
    "entryDate": "2025-10-02",
    "exitDate": "2025-10-06",
    "entryTime": "11:45AM",
    "exitTime": "2:50PM",
    "strike": 205,
    "type": "Put",
    "expiration": "2025-10-10",
    "entryPrice": 0.68,
    "exitPrice": 1.03,
    "entryStock": 207.87,
    "exitStock": 202.92,
    "contracts": 2,
    "returnPct": 51.47,
    "pnl": 70,
    "notes": "News catalyst, got in early",
    "updatedAt": 1759363317000,
    "deleted": false
  },
  {
    "uid": "demo-0119-nflx-2025-10-10",
    "ticker": "NFLX",
    "entryDate": "2025-10-10",
    "exitDate": "2025-10-17",
    "entryTime": "10:10AM",
    "exitTime": "11:30AM",
    "strike": 805,
    "type": "Call",
    "expiration": "2025-10-17",
    "entryPrice": 1.15,
    "exitPrice": 1.77,
    "entryStock": 799.76,
    "exitStock": 801.12,
    "contracts": 3,
    "returnPct": 53.91,
    "pnl": 186,
    "notes": "Overnight hold — gap up at open, easy exit",
    "updatedAt": 1760054518000,
    "deleted": false
  },
  {
    "uid": "demo-0120-msft-2025-10-14",
    "ticker": "MSFT",
    "entryDate": "2025-10-14",
    "exitDate": "2025-10-17",
    "entryTime": "3:10PM",
    "exitTime": "10:20AM",
    "strike": 425,
    "type": "Put",
    "expiration": "2025-10-24",
    "entryPrice": 0.72,
    "exitPrice": 2.55,
    "entryStock": 425.33,
    "exitStock": 420.74,
    "contracts": 1,
    "returnPct": 254.17,
    "pnl": 183,
    "notes": "Faded the gap, worked out",
    "updatedAt": 1760400119000,
    "deleted": false
  },
  {
    "uid": "demo-0121-aapl-2025-10-15",
    "ticker": "AAPL",
    "entryDate": "2025-10-15",
    "exitDate": "2025-10-15",
    "entryTime": "10:00AM",
    "exitTime": "10:12AM",
    "strike": 205,
    "type": "Put",
    "expiration": "2025-10-15",
    "entryPrice": 0.15,
    "exitPrice": 0.21,
    "entryStock": 209.57,
    "exitStock": 205.08,
    "contracts": 1,
    "returnPct": 40,
    "pnl": 6,
    "notes": "Held through lunch chop — mistake",
    "updatedAt": 1760486520000,
    "deleted": false
  },
  {
    "uid": "demo-0122-msft-2025-10-24",
    "ticker": "MSFT",
    "entryDate": "2025-10-24",
    "exitDate": "2025-10-24",
    "entryTime": "3:10PM",
    "exitTime": "3:51PM",
    "strike": 370,
    "type": "Put",
    "expiration": "2025-10-24",
    "entryPrice": 1.17,
    "exitPrice": 1.11,
    "entryStock": 374.63,
    "exitStock": 377.05,
    "contracts": 1,
    "returnPct": -5.13,
    "pnl": -6,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1761264121000,
    "deleted": false
  },
  {
    "uid": "demo-0123-nflx-2025-11-03",
    "ticker": "NFLX",
    "entryDate": "2025-11-03",
    "exitDate": "2025-11-07",
    "entryTime": "9:45AM",
    "exitTime": "2:40PM",
    "strike": 995,
    "type": "Put",
    "expiration": "2025-11-07",
    "entryPrice": 1.17,
    "exitPrice": 1.8,
    "entryStock": 997.66,
    "exitStock": 995.41,
    "contracts": 1,
    "returnPct": 53.85,
    "pnl": 63,
    "notes": "Entered late in the day, exited next morning",
    "updatedAt": 1762128122000,
    "deleted": false
  },
  {
    "uid": "demo-0124-aapl-2025-11-03",
    "ticker": "AAPL",
    "entryDate": "2025-11-03",
    "exitDate": "2025-11-04",
    "entryTime": "10:15AM",
    "exitTime": "2:45PM",
    "strike": 245,
    "type": "Call",
    "expiration": "2025-11-07",
    "entryPrice": 0.86,
    "exitPrice": 1.22,
    "entryStock": 246.2,
    "exitStock": 248.54,
    "contracts": 2,
    "returnPct": 41.86,
    "pnl": 72,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1762128123000,
    "deleted": false
  },
  {
    "uid": "demo-0125-aapl-2025-11-11",
    "ticker": "AAPL",
    "entryDate": "2025-11-11",
    "exitDate": "2025-11-25",
    "entryTime": "11:30AM",
    "exitTime": "2:50PM",
    "strike": 210,
    "type": "Put",
    "expiration": "2025-12-05",
    "entryPrice": 0.55,
    "exitPrice": 0.72,
    "entryStock": 211.9,
    "exitStock": 211.32,
    "contracts": 2,
    "returnPct": 30.91,
    "pnl": 34,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1762819324000,
    "deleted": false
  },
  {
    "uid": "demo-0126-aapl-2025-11-17",
    "ticker": "AAPL",
    "entryDate": "2025-11-17",
    "exitDate": "2025-11-19",
    "entryTime": "12:30PM",
    "exitTime": "10:05AM",
    "strike": 245,
    "type": "Put",
    "expiration": "2025-11-28",
    "entryPrice": 1.21,
    "exitPrice": 0.96,
    "entryStock": 243.58,
    "exitStock": 246.82,
    "contracts": 1,
    "returnPct": -20.66,
    "pnl": -25,
    "notes": "Swung this over the weekend, risky but paid off",
    "updatedAt": 1763337725000,
    "deleted": false
  },
  {
    "uid": "demo-0127-amzn-2025-11-24",
    "ticker": "AMZN",
    "entryDate": "2025-11-24",
    "exitDate": "2025-11-24",
    "entryTime": "11:00AM",
    "exitTime": "11:51AM",
    "strike": 220,
    "type": "Put",
    "expiration": "2025-11-24",
    "entryPrice": 2.19,
    "exitPrice": 2.61,
    "entryStock": 219.06,
    "exitStock": 215.6,
    "contracts": 1,
    "returnPct": 19.18,
    "pnl": 42,
    "notes": "Was right on direction but strike too far OTM",
    "updatedAt": 1763942526000,
    "deleted": false
  },
  {
    "uid": "demo-0128-googl-2025-12-02",
    "ticker": "GOOGL",
    "entryDate": "2025-12-02",
    "exitDate": "2025-12-02",
    "entryTime": "12:30PM",
    "exitTime": "1:01PM",
    "strike": 152.5,
    "type": "Call",
    "expiration": "2025-12-02",
    "entryPrice": 0.88,
    "exitPrice": 1.18,
    "entryStock": 153.83,
    "exitStock": 158.36,
    "contracts": 3,
    "returnPct": 34.09,
    "pnl": 90,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1764633727000,
    "deleted": false
  },
  {
    "uid": "demo-0129-crwd-2025-12-08",
    "ticker": "CRWD",
    "entryDate": "2025-12-08",
    "exitDate": "2025-12-11",
    "entryTime": "2:00PM",
    "exitTime": "2:35PM",
    "strike": 385,
    "type": "Put",
    "expiration": "2025-12-12",
    "entryPrice": 2.1,
    "exitPrice": 2.3,
    "entryStock": 383.28,
    "exitStock": 382.09,
    "contracts": 1,
    "returnPct": 9.52,
    "pnl": 20,
    "notes": "Held through earnings — won't do that again",
    "updatedAt": 1765152128000,
    "deleted": false
  },
  {
    "uid": "demo-0130-uber-2025-12-11",
    "ticker": "UBER",
    "entryDate": "2025-12-11",
    "exitDate": "2025-12-15",
    "entryTime": "12:00PM",
    "exitTime": "12:00PM",
    "strike": 75,
    "type": "Call",
    "expiration": "2025-12-19",
    "entryPrice": 0.05,
    "exitPrice": 0.02,
    "entryStock": 71.31,
    "exitStock": 67.5,
    "contracts": 1,
    "returnPct": -60,
    "pnl": -3,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1765411329000,
    "deleted": false
  },
  {
    "uid": "demo-0131-msft-2025-12-12",
    "ticker": "MSFT",
    "entryDate": "2025-12-12",
    "exitDate": "2025-12-16",
    "entryTime": "3:30PM",
    "exitTime": "3:00PM",
    "strike": 420,
    "type": "Put",
    "expiration": "2025-12-26",
    "entryPrice": 3.33,
    "exitPrice": 4.08,
    "entryStock": 416.88,
    "exitStock": 412.23,
    "contracts": 1,
    "returnPct": 22.52,
    "pnl": 75,
    "notes": "News catalyst, got in early",
    "updatedAt": 1765497730000,
    "deleted": false
  },
  {
    "uid": "demo-0132-uber-2025-12-16",
    "ticker": "UBER",
    "entryDate": "2025-12-16",
    "exitDate": "2025-12-16",
    "entryTime": "12:30PM",
    "exitTime": "12:52PM",
    "strike": 65,
    "type": "Call",
    "expiration": "2025-12-16",
    "entryPrice": 0.42,
    "exitPrice": 0.55,
    "entryStock": 65.42,
    "exitStock": 68.65,
    "contracts": 1,
    "returnPct": 30.95,
    "pnl": 13,
    "notes": "",
    "updatedAt": 1765843331000,
    "deleted": false
  },
  {
    "uid": "demo-0133-hims-2025-12-16",
    "ticker": "HIMS",
    "entryDate": "2025-12-16",
    "exitDate": "2025-12-16",
    "entryTime": "1:15PM",
    "exitTime": "1:19PM",
    "strike": 52.5,
    "type": "Call",
    "expiration": "2025-12-16",
    "entryPrice": 0.11,
    "exitPrice": 0.15,
    "entryStock": 51.7,
    "exitStock": 56.49,
    "contracts": 4,
    "returnPct": 36.36,
    "pnl": 16,
    "notes": "Overextended entry, should've been a put",
    "updatedAt": 1765843332000,
    "deleted": false
  },
  {
    "uid": "demo-0134-msft-2025-12-24",
    "ticker": "MSFT",
    "entryDate": "2025-12-24",
    "exitDate": "2025-12-24",
    "entryTime": "10:05AM",
    "exitTime": "11:20AM",
    "strike": 460,
    "type": "Call",
    "expiration": "2025-12-24",
    "entryPrice": 2.36,
    "exitPrice": 1.75,
    "entryStock": 458.66,
    "exitStock": 455.05,
    "contracts": 2,
    "returnPct": -25.85,
    "pnl": -122,
    "notes": "Tight spread, clean fill",
    "updatedAt": 1766534533000,
    "deleted": false
  },
  {
    "uid": "demo-0135-sq-2025-12-31",
    "ticker": "SQ",
    "entryDate": "2025-12-31",
    "exitDate": "2026-01-01",
    "entryTime": "2:00PM",
    "exitTime": "9:40AM",
    "strike": 82.5,
    "type": "Call",
    "expiration": "2026-01-09",
    "entryPrice": 0.25,
    "exitPrice": 0.63,
    "entryStock": 81.91,
    "exitStock": 85.55,
    "contracts": 1,
    "returnPct": 152,
    "pnl": 38,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1767139334000,
    "deleted": false
  },
  {
    "uid": "demo-0136-uber-2025-12-31",
    "ticker": "UBER",
    "entryDate": "2025-12-31",
    "exitDate": "2025-12-31",
    "entryTime": "1:30PM",
    "exitTime": "1:34PM",
    "strike": 80,
    "type": "Put",
    "expiration": "2025-12-31",
    "entryPrice": 0.38,
    "exitPrice": 0.41,
    "entryStock": 78.41,
    "exitStock": 75.47,
    "contracts": 1,
    "returnPct": 7.89,
    "pnl": 3,
    "notes": "Theta ate into this — held too long",
    "updatedAt": 1767139335000,
    "deleted": false
  },
  {
    "uid": "demo-0137-meta-2026-01-09",
    "ticker": "META",
    "entryDate": "2026-01-09",
    "exitDate": "2026-01-12",
    "entryTime": "11:45AM",
    "exitTime": "3:40PM",
    "strike": 580,
    "type": "Call",
    "expiration": "2026-01-16",
    "entryPrice": 4.56,
    "exitPrice": 4.95,
    "entryStock": 581.66,
    "exitStock": 584.36,
    "contracts": 2,
    "returnPct": 8.55,
    "pnl": 78,
    "notes": "RSI oversold bounce",
    "updatedAt": 1767916936000,
    "deleted": false
  },
  {
    "uid": "demo-0138-meta-2026-01-19",
    "ticker": "META",
    "entryDate": "2026-01-19",
    "exitDate": "2026-01-19",
    "entryTime": "3:20PM",
    "exitTime": "3:27PM",
    "strike": 640,
    "type": "Call",
    "expiration": "2026-01-19",
    "entryPrice": 1.55,
    "exitPrice": 2.5,
    "entryStock": 632.66,
    "exitStock": 634.88,
    "contracts": 2,
    "returnPct": 61.29,
    "pnl": 190,
    "notes": "Perfect setup, textbook execution",
    "updatedAt": 1768780937000,
    "deleted": false
  },
  {
    "uid": "demo-0139-msft-2026-01-22",
    "ticker": "MSFT",
    "entryDate": "2026-01-22",
    "exitDate": "2026-02-02",
    "entryTime": "12:30PM",
    "exitTime": "Expired",
    "strike": 440,
    "type": "Call",
    "expiration": "2026-02-06",
    "entryPrice": 0.43,
    "exitPrice": 0,
    "entryStock": 435.62,
    "exitStock": 431.26,
    "contracts": 1,
    "returnPct": -100,
    "pnl": -43,
    "notes": "Morning dip buy, rode the recovery",
    "updatedAt": 1769040138000,
    "deleted": false
  },
  {
    "uid": "demo-0140-amzn-2026-01-29",
    "ticker": "AMZN",
    "entryDate": "2026-01-29",
    "exitDate": "2026-01-29",
    "entryTime": "9:40AM",
    "exitTime": "10:09AM",
    "strike": 192.5,
    "type": "Put",
    "expiration": "2026-01-29",
    "entryPrice": 0.87,
    "exitPrice": 1.22,
    "entryStock": 194.17,
    "exitStock": 193.61,
    "contracts": 1,
    "returnPct": 40.23,
    "pnl": 35,
    "notes": "Power hour momentum play",
    "updatedAt": 1769644939000,
    "deleted": false
  },
  {
    "uid": "demo-0141-msft-2026-01-30",
    "ticker": "MSFT",
    "entryDate": "2026-01-30",
    "exitDate": "2026-01-30",
    "entryTime": "10:10AM",
    "exitTime": "10:23AM",
    "strike": 445,
    "type": "Call",
    "expiration": "2026-01-30",
    "entryPrice": 3.65,
    "exitPrice": 12.81,
    "entryStock": 447.46,
    "exitStock": 450.08,
    "contracts": 1,
    "returnPct": 250.96,
    "pnl": 916,
    "notes": "Multi-day swing, caught the trend perfectly",
    "updatedAt": 1769731340000,
    "deleted": false
  },
  {
    "uid": "demo-0142-hims-2026-01-30",
    "ticker": "HIMS",
    "entryDate": "2026-01-30",
    "exitDate": "2026-02-04",
    "entryTime": "2:40PM",
    "exitTime": "9:32AM",
    "strike": 52.5,
    "type": "Put",
    "expiration": "2026-02-13",
    "entryPrice": 0.1,
    "exitPrice": 0.08,
    "entryStock": 53.42,
    "exitStock": 55.3,
    "contracts": 2,
    "returnPct": -20,
    "pnl": -4,
    "notes": "Day trade, 15 min hold, clean",
    "updatedAt": 1769731341000,
    "deleted": false
  },
  {
    "uid": "demo-0143-aapl-2026-02-10",
    "ticker": "AAPL",
    "entryDate": "2026-02-10",
    "exitDate": "2026-02-10",
    "entryTime": "2:15PM",
    "exitTime": "2:20PM",
    "strike": 240,
    "type": "Put",
    "expiration": "2026-02-10",
    "entryPrice": 0.62,
    "exitPrice": 0.78,
    "entryStock": 240.79,
    "exitStock": 235.8,
    "contracts": 2,
    "returnPct": 25.81,
    "pnl": 32,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1770681742000,
    "deleted": false
  },
  {
    "uid": "demo-0144-aapl-2026-02-19",
    "ticker": "AAPL",
    "entryDate": "2026-02-19",
    "exitDate": "2026-02-19",
    "entryTime": "3:15PM",
    "exitTime": "3:52PM",
    "strike": 240,
    "type": "Put",
    "expiration": "2026-02-19",
    "entryPrice": 1.12,
    "exitPrice": 0.62,
    "entryStock": 240.82,
    "exitStock": 242.39,
    "contracts": 1,
    "returnPct": -44.64,
    "pnl": -50,
    "notes": "",
    "updatedAt": 1771459343000,
    "deleted": false
  },
  {
    "uid": "demo-0145-hims-2026-02-20",
    "ticker": "HIMS",
    "entryDate": "2026-02-20",
    "exitDate": "2026-03-03",
    "entryTime": "1:00PM",
    "exitTime": "3:40PM",
    "strike": 50,
    "type": "Call",
    "expiration": "2026-03-06",
    "entryPrice": 0.14,
    "exitPrice": 0.18,
    "entryStock": 48.51,
    "exitStock": 52.18,
    "contracts": 1,
    "returnPct": 28.57,
    "pnl": 4,
    "notes": "Overnight hold — gap up at open, easy exit",
    "updatedAt": 1771545744000,
    "deleted": false
  },
  {
    "uid": "demo-0146-meta-2026-02-20",
    "ticker": "META",
    "entryDate": "2026-02-20",
    "exitDate": "2026-02-25",
    "entryTime": "10:45AM",
    "exitTime": "3:15PM",
    "strike": 605,
    "type": "Call",
    "expiration": "2026-02-27",
    "entryPrice": 3.13,
    "exitPrice": 1.83,
    "entryStock": 603.4,
    "exitStock": 599.1,
    "contracts": 2,
    "returnPct": -41.53,
    "pnl": -260,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1771545745000,
    "deleted": false
  },
  {
    "uid": "demo-0147-googl-2026-02-23",
    "ticker": "GOOGL",
    "entryDate": "2026-02-23",
    "exitDate": "2026-02-24",
    "entryTime": "11:45AM",
    "exitTime": "11:45AM",
    "strike": 160,
    "type": "Put",
    "expiration": "2026-02-27",
    "entryPrice": 0.49,
    "exitPrice": 0.74,
    "entryStock": 165.69,
    "exitStock": 162.38,
    "contracts": 1,
    "returnPct": 51.02,
    "pnl": 25,
    "notes": "EMA 9/21 cross confirmed — clean entry",
    "updatedAt": 1771804946000,
    "deleted": false
  },
  {
    "uid": "demo-0148-crm-2026-02-27",
    "ticker": "CRM",
    "entryDate": "2026-02-27",
    "exitDate": "2026-03-02",
    "entryTime": "10:05AM",
    "exitTime": "9:50AM",
    "strike": 280,
    "type": "Call",
    "expiration": "2026-03-06",
    "entryPrice": 0.79,
    "exitPrice": 0.9,
    "entryStock": 281.56,
    "exitStock": 284.16,
    "contracts": 2,
    "returnPct": 13.92,
    "pnl": 22,
    "notes": "Pre-market gap fill setup",
    "updatedAt": 1772150547000,
    "deleted": false
  },
  {
    "uid": "demo-0149-nvda-2026-02-27",
    "ticker": "NVDA",
    "entryDate": "2026-02-27",
    "exitDate": "2026-02-27",
    "entryTime": "1:45PM",
    "exitTime": "3:03PM",
    "strike": 135,
    "type": "Put",
    "expiration": "2026-02-27",
    "entryPrice": 0.41,
    "exitPrice": 0.34,
    "entryStock": 137.43,
    "exitStock": 141.06,
    "contracts": 1,
    "returnPct": -17.07,
    "pnl": -7,
    "notes": "Averaged down — bad habit",
    "updatedAt": 1772150548000,
    "deleted": false
  },
  {
    "uid": "demo-0150-nvda-2026-03-05",
    "ticker": "NVDA",
    "entryDate": "2026-03-05",
    "exitDate": "2026-03-06",
    "entryTime": "9:40AM",
    "exitTime": "9:55AM",
    "strike": 142.5,
    "type": "Call",
    "expiration": "2026-03-13",
    "entryPrice": 0.33,
    "exitPrice": 0.96,
    "entryStock": 140.98,
    "exitStock": 145.84,
    "contracts": 1,
    "returnPct": 190.91,
    "pnl": 63,
    "notes": "IV crush after earnings — lesson learned",
    "updatedAt": 1772668949000,
    "deleted": false
  },
  {
    "uid": "demo-0151-amzn-2026-03-11",
    "ticker": "AMZN",
    "entryDate": "2026-03-11",
    "exitDate": "2026-03-12",
    "entryTime": "2:45PM",
    "exitTime": "10:30AM",
    "strike": 212.5,
    "type": "Call",
    "expiration": "2026-03-13",
    "entryPrice": 1.14,
    "exitPrice": 1.54,
    "entryStock": 213.91,
    "exitStock": 215.52,
    "contracts": 2,
    "returnPct": 35.09,
    "pnl": 80,
    "notes": "",
    "updatedAt": 1773187350000,
    "deleted": false
  },
  {
    "uid": "demo-0152-msft-2026-03-13",
    "ticker": "MSFT",
    "entryDate": "2026-03-13",
    "exitDate": "2026-03-17",
    "entryTime": "1:15PM",
    "exitTime": "Expired",
    "strike": 455,
    "type": "Call",
    "expiration": "2026-03-20",
    "entryPrice": 2.03,
    "exitPrice": 0,
    "entryStock": 452.9,
    "exitStock": 452.43,
    "contracts": 1,
    "returnPct": -100,
    "pnl": -203,
    "notes": "",
    "updatedAt": 1773360151000,
    "deleted": false
  },
  {
    "uid": "demo-0153-msft-2026-03-17",
    "ticker": "MSFT",
    "entryDate": "2026-03-17",
    "exitDate": "2026-03-18",
    "entryTime": "10:45AM",
    "exitTime": "2:50PM",
    "strike": 450,
    "type": "Call",
    "expiration": "2026-03-20",
    "entryPrice": 1.14,
    "exitPrice": 1.22,
    "entryStock": 445.87,
    "exitStock": 446.96,
    "contracts": 2,
    "returnPct": 7.02,
    "pnl": 16,
    "notes": "Waited for the pullback — patience paid off",
    "updatedAt": 1773705752000,
    "deleted": false
  },
  {
    "uid": "demo-0154-amzn-2026-03-18",
    "ticker": "AMZN",
    "entryDate": "2026-03-18",
    "exitDate": "2026-03-18",
    "entryTime": "10:30AM",
    "exitTime": "10:41AM",
    "strike": 222.5,
    "type": "Put",
    "expiration": "2026-03-18",
    "entryPrice": 1.97,
    "exitPrice": 2.86,
    "entryStock": 219.75,
    "exitStock": 219.14,
    "contracts": 1,
    "returnPct": 45.18,
    "pnl": 89,
    "notes": "Averaged down — bad habit",
    "updatedAt": 1773792153000,
    "deleted": false
  },
  {
    "uid": "demo-0155-msft-2026-03-19",
    "ticker": "MSFT",
    "entryDate": "2026-03-19",
    "exitDate": "2026-03-19",
    "entryTime": "3:00PM",
    "exitTime": "3:15PM",
    "strike": 385,
    "type": "Call",
    "expiration": "2026-03-20",
    "entryPrice": 0.73,
    "exitPrice": 0.98,
    "entryStock": 381.5,
    "exitStock": 386.2,
    "contracts": 1,
    "returnPct": 34.25,
    "pnl": 25,
    "notes": "Fed minutes reaction — quick scalp",
    "updatedAt": 1773878554000,
    "deleted": false
  },
  {
    "uid": "demo-0156-hims-2026-03-19",
    "ticker": "HIMS",
    "entryDate": "2026-03-19",
    "exitDate": "2026-03-19",
    "entryTime": "9:38AM",
    "exitTime": "9:40AM",
    "strike": 52.5,
    "type": "Put",
    "expiration": "2026-03-27",
    "entryPrice": 0.28,
    "exitPrice": 0.25,
    "entryStock": 53.37,
    "exitStock": 56,
    "contracts": 5,
    "returnPct": -10.71,
    "pnl": -15,
    "notes": "Broke key resistance level with volume",
    "updatedAt": 1773878555000,
    "deleted": false
  }
];
